import { Box, Flex, Skeleton } from '@/components';
import type { FC } from 'react';

export const AnalysisSearchSkeleton: FC = () => {
  return (
    <Box bordered padding={16} borderRadius={0}>
      <Flex gap="4px 0" wrap="wrap" vertical>
        <Flex gap={8}>
          <Skeleton.Avatar active size="small" />
          <Skeleton.Input active size="small" />
        </Flex>
        <Flex
          vertical
          style={{
            paddingLeft: 32,
          }}
        >
          <Skeleton.Input active size="large" />
        </Flex>
      </Flex>
    </Box>
  );
};
